import SLICE from './_create.slice';

const { REDUCERPARTS } = SLICE;

export const reducerParts = REDUCERPARTS;

export default reducerParts;